import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const noExtraSpacesValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;
  if (typeof value === 'string') {
    const trimmedValue = value.trim();
    if (trimmedValue.length === 0 && value.length > 0) {
      return { allWhitespace: true };
    }

    if (/\s{2,}/g.test(trimmedValue)) {
      return {
        noExtraSpaces: true,
        message: 'No se permiten múltiples espacios consecutivos.',
      };
    }
  }
  return null;
};
